export default "__VITE_ASSET__7590438e__"